import { Box, Flex, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import SkeletonComponent from 'UiKit/skeleton';
import PaginationSkeleton from 'Component/skeleton/pagination';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const ScheduleRulesetSkeleton = () => {
  return (
    <Box padding="32px 24px">
      <Flex mb="12px" className={styles['section__head']}>
        <SkeletonComponent height="34px" width="200px" />
      </Flex>

      <Flex className={styles['section__filter']}>
        <Flex gap="12px">
          <SkeletonComponent height="34px" width="380px" />
          <SkeletonComponent height="34px" width="200px" />
        </Flex>

        <SkeletonComponent height="34px" width="180px" />
      </Flex>

      <Box className={styles['section__table']}>
        <Table className={styles['table__skeleton']}>
          <Thead>
            <Tr>
              <Th width="82px" className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="30%" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th width="250px" className={styles['skeleton__head']}>
                <SkeletonComponent height="21px" width="20%" mb="2px" />
              </Th>
              <Th width="124px" className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="50%" mb="2px" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th width="90px" className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="50%" mb="2px" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th width="142px" className={styles['skeleton__head']}>
                <Flex justifyContent="space-between">
                  <SkeletonComponent height="21px" width="50%" mb="2px" />
                  <SkeletonComponent height="21px" width="21px" />
                </Flex>
              </Th>
              <Th width="106px" className={styles['skeleton__head']}>
                <Flex justifyContent="center">
                  <SkeletonComponent height="21px" width="30%" mb="2px" />
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Iteration
              items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
              render={(num) => {
                return (
                  <Tr key={num}>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>
                    <Td className={styles['skeleton__column']}>
                      <Flex gap="4px">
                        <SkeletonComponent height="21px" width="30%" mb="2px" />
                        <SkeletonComponent height="21px" width="20%" mb="2px" />
                      </Flex>
                    </Td>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>
                    <Td className={styles['skeleton__column']}>
                      <SkeletonComponent height="21px" width="90%" mb="2px" />
                    </Td>
                    <Td className={styles['skeleton__column']}>
                      <Flex gap="4px" justifyContent="center">
                        <SkeletonComponent height="32px" width="32px" borderRadius="8px" />
                        <SkeletonComponent height="32px" width="32px" borderRadius="8px" />
                      </Flex>
                    </Td>
                  </Tr>
                );
              }}
            />
          </Tbody>
        </Table>
      </Box>

      <Box className={styles['section__pagination--wrapper']}>
        <Box className={styles['section__pagination']}>
          <PaginationSkeleton />
        </Box>
      </Box>
    </Box>
  );
};

export default ScheduleRulesetSkeleton;
